// libs/shared/ui/builder/src/lib/components/auth/AgentAuth.tsx
import React, { useState } from "react";
import AgentAuthSignIn, { type AuthView } from "./AgentAuthSignIn";
import AgentAuthForgotPassword from "./AgentAuthForgotPassword";
import AgentAuthForgotId from "./AgentAuthForgotId";
import AgentAuthRegister from "./AgentAuthRegister";

interface Props {
  initialView?: AuthView;
}

export default function AgentAuth({ initialView = "signin" }: Props) {
  const [view, setView] = useState<AuthView>(initialView);

  const authServiceUrl = process.env["NEXT_PUBLIC_AUTH_SERVICE_URL"] ?? "";
  const esignatureApiUrl = process.env["NEXT_PUBLIC_ESIGNATURE_API_URL"] ?? "";
  const agentPortalUrl =
    process.env["NEXT_PUBLIC_AGENT_PORTAL_URL"] ??
    "https://agents.pivothealth.com/";

  if (view === "forgot-password") {
    return (
      <AgentAuthForgotPassword
        authServiceUrl={authServiceUrl}
        onNavigate={setView}
      />
    );
  }

  if (view === "forgot-agent-id") {
    return (
      <AgentAuthForgotId
        esignatureApiUrl={esignatureApiUrl}
        onNavigate={setView}
      />
    );
  }

  if (view === "register") {
    return (
      <AgentAuthRegister authServiceUrl={authServiceUrl} onNavigate={setView} />
    );
  }

  // Default: "signin"
  return (
    <AgentAuthSignIn
      authServiceUrl={authServiceUrl}
      agentPortalUrl={agentPortalUrl}
      onNavigate={setView}
    />
  );
}
